import { Component } from '@theme/component';

/**
 * Bundle picker: copies the selected option (number of sets) into the product form's
 * quantity selector in the same section. The saving is applied by an automatic discount.
 *
 * @extends {Component}
 */
class BundlePicker extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#applyChecked();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#applyChecked();
  }

  /**
   * Handles a change of the selected option.
   * @param {Event} event - The change event from a radio input.
   */
  select(event) {
    if (!(event.target instanceof HTMLInputElement)) return;
    this.#setQuantity(event.target.value);
  }

  async #applyChecked() {
    // The quantity selector's module can register after this one.
    await customElements.whenDefined('quantity-selector-component');
    const checked = this.querySelector('.bundle-picker__input:checked');
    if (checked instanceof HTMLInputElement) this.#setQuantity(checked.value);
  }

  /**
   * @param {string} value - The quantity to set.
   */
  #setQuantity(value) {
    const section = this.closest('.shopify-section');
    const selector = /** @type {any} */ (section?.querySelector('product-form-component quantity-selector-component'));
    if (!selector || typeof selector.setValue !== 'function') return;
    if (selector.getValue?.() === value) return;

    selector.setValue(value);
    // Broadcast like a manual change so the sticky add-to-cart bar stays in sync.
    selector.onQuantityChange?.();
    selector.updateButtonStates?.();
  }
}

if (!customElements.get('bundle-picker')) {
  customElements.define('bundle-picker', BundlePicker);
}
